import Proposals from './routes/Proposals';
import Authorities from './routes/Authorities';
import Headings from './routes/Headings';
import Imports from './routes/Imports';
import Vocabularies from './routes/Vocabularies';
import ReviewQueue from './routes/ReviewQueue';
import Inbox from './routes/Inbox';
import ErrorReports from './routes/ErrorReports';
import CorpusQuality from './routes/CorpusQuality';
import FormConfigSettings from './settings/FormConfigSettings';
import ValidationRules from './routes/ValidationRules';
import DerivationRules from './routes/DerivationRules';
import SemanticCatalogBrowser from './settings/SemanticCatalogBrowser';
import HelpTextSettings from './settings/HelpTextSettings';
import VocabularyTypes from './routes/VocabularyTypes';
import OaiHarvestSettings from './settings/OaiHarvestSettings';
import { CORPUS_QUALITY_CAPABILITY } from './utils/corpusQualityAccess';
import { ERROR_REPORTS_CAPABILITY } from './utils/errorReportsAccess';
import { OAI_HARVEST_CAPABILITY, SETTINGS_CAPABILITY, VOCABULARY_TYPES_CAPABILITY, } from './utils/settingsAccess';
export var routesConfig = {
    proposals: {
        path: '/proposals',
        component: Proposals,
    },
    authorities: {
        path: '/authorities',
        component: Authorities,
    },
    headings: {
        path: '/headings',
        component: Headings,
    },
    vocabularies: {
        path: '/vocabularies',
        component: Vocabularies,
    },
    corpusQuality: {
        path: '/corpus-quality',
        component: CorpusQuality,
        perm: CORPUS_QUALITY_CAPABILITY,
    },
    imports: {
        path: '/import',
        component: Imports,
        perm: SETTINGS_CAPABILITY,
    },
    // CZNA-1446 — everything waiting on the signed-in user; `/review-queue` is the
    // administrator's "Všechny kontroly".
    inbox: {
        path: '/inbox',
        component: Inbox,
    },
    reviewQueue: {
        path: '/review-queue',
        component: ReviewQueue,
    },
    // CZNA-1596 — public error reports, for the NK supervisor of the record's type and the
    // authority administrator.
    errorReports: {
        path: '/error-reports',
        component: ErrorReports,
        perm: ERROR_REPORTS_CAPABILITY,
    },
    settings: {
        path: '/settings',
        component: FormConfigSettings,
        perm: SETTINGS_CAPABILITY,
    },
    // CZNA-328: the standalone `/validation-rules/tester` page was removed; its
    // capability is merged into the MARC Checker modal (opened from this list's
    // top button = all rules, or from a rule's detail = that one rule).
    validationRules: {
        path: '/validation-rules',
        component: ValidationRules,
        perm: SETTINGS_CAPABILITY,
    },
    // CZNA-365 (epic CZNA-297) — vocabulary derivation rule admin GUI.
    derivationRules: {
        path: '/derivation-rules',
        component: DerivationRules,
        perm: SETTINGS_CAPABILITY,
    },
    // CZNA-419 (epic CZNA-368, WP-P6a) — ontology browser (ADR-0007).
    semanticCatalog: {
        path: '/semantic-catalog',
        component: SemanticCatalogBrowser,
        perm: SETTINGS_CAPABILITY,
    },
    // CZNA-407 — NK rewords the in-app help without a deploy.
    helpTexts: {
        path: '/help-texts',
        component: HelpTextSettings,
        perm: SETTINGS_CAPABILITY,
    },
    // CZNA-1470 — the vocabularies themselves (create, rename); the terms stay under /vocabularies.
    vocabularyTypes: {
        path: '/vocabulary-types',
        component: VocabularyTypes,
        perm: VOCABULARY_TYPES_CAPABILITY,
    },
    // CZNA-1562 — who harvests over OAI-PMH and how it goes; the harvest endpoints' permission.
    oaiHarvest: {
        path: '/oai-harvest',
        component: OaiHarvestSettings,
        perm: OAI_HARVEST_CAPABILITY,
    },
};
